import React from 'react';
import { api_host } from '../../../common/globals/constants';
import { useQuery } from '@tanstack/react-query';

export const useFetchDisponibility = ({
  urlParams,
  fetchApi,
  enabled = true,
  refreshTime = false,
}) => {
  return useQuery({
    queryKey: ['disponibility', fetchApi, urlParams.toString()],
    queryFn: async () => {
      const response = await fetch(
        `${api_host}/reporte/online/indicadores/${fetchApi}/?${urlParams.toString()}`
      );
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    },
    enabled,
    gcTime: 0, // 24 hours
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: refreshTime || false,
  });
};
